import React from 'react';

// Shared inline icon set (no dependency) — 24px viewBox, stroke = currentColor,
// sized via the `size` prop. Used by the app shell (Sidebar, Navbar) and the
// Home dashboard. Add paths here rather than importing an icon library.
const PATHS = {
  home: 'M3 10.5 12 3l9 7.5M5 9.5V21h5v-6h4v6h5V9.5',
  plus: 'M12 5v14M5 12h14',
  folder: 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z',
  doc: 'M6 3h8l4 4v14H6V3ZM14 3v4h4M9 12h6M9 16h6',
  deck: 'M3 4h18M5 4h14v11H5V4ZM12 15v3m-4 3 4-3 4 3M8 8h6M8 11h4',
  sheet: 'M4 4h16v16H4V4ZM4 9.3h16M4 14.6h16M10 4v16',
  activity: 'M3 12h4l2.5-7 5 14L17 12h4',
  users: 'M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M9.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM21 21v-2a4 4 0 0 0-3-3.87M15 3.13a4 4 0 0 1 0 7.75',
  book: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20V2H6.5A2.5 2.5 0 0 0 4 4.5v15ZM4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.4 7.4 0 0 0-.1-1.2l2-1.5-2-3.5-2.4 1a7.6 7.6 0 0 0-2-1.2L14.5 3h-5l-.4 2.6a7.6 7.6 0 0 0-2 1.2l-2.4-1-2 3.5 2 1.5a7.4 7.4 0 0 0 0 2.4l-2 1.5 2 3.5 2.4-1a7.6 7.6 0 0 0 2 1.2l.4 2.6h5l.4-2.6a7.6 7.6 0 0 0 2-1.2l2.4 1 2-3.5-2-1.5c.06-.4.1-.8.1-1.2Z',
  help: 'M9 9a3 3 0 1 1 4.6 2.5c-.9.6-1.6 1.2-1.6 2.5M12 17.5h.01M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm10 3-5-5',
  bell: 'M18 8a6 6 0 1 0-12 0c0 7-3 8-3 8h18s-3-1-3-8ZM10.3 21a2 2 0 0 0 3.4 0',
  brain: 'M9.5 3A3 3 0 0 0 6.6 5.2 3 3 0 0 0 4.3 8.3 3 3 0 0 0 4 12a3 3 0 0 0 .6 3.5A3 3 0 0 0 7 19.3 2.7 2.7 0 0 0 9.5 21c1.4 0 2.5-1 2.5-2.5v-13C12 4 10.9 3 9.5 3ZM14.5 3A3 3 0 0 1 17.4 5.2a3 3 0 0 1 2.3 3.1A3 3 0 0 1 20 12a3 3 0 0 1-.6 3.5A3 3 0 0 1 17 19.3 2.7 2.7 0 0 1 14.5 21c-1.4 0-2.5-1-2.5-2.5v-13C12 4 13.1 3 14.5 3ZM12 8h-2M12 12h2M12 16h-2',
  sparkle: 'M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3ZM19 15l.9 2.4L22.3 18l-2.4.9L19 21.3l-.9-2.4-2.4-.9 2.4-.9L19 15Z',
  upload: 'M12 16V4m0 0 4 4m-4-4L8 8M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3',
  pen: 'M17 3a2.8 2.8 0 0 1 4 4L7.5 20.5 3 22l1.5-4.5L17 3Z',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  shield: 'M12 22s8-3.5 8-10V5l-8-3-8 3v7c0 6.5 8 10 8 10Z',
  compare: 'M10 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5M14 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5M12 1v22',
  list: 'M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01',
  chat: 'M21 12a8 8 0 0 1-8 8H4l2-3a8 8 0 1 1 15-5ZM9 11h.01M13 11h.01M17 11h.01',
  key: 'M15 11a4 4 0 1 0-4-4c0 .6.1 1.1.3 1.6L3 17v4h4l1.5-1.5V17H11l1.4-1.4c.5.2 1 .4 1.6.4Z',
  chevronDown: 'm6 9 6 6 6-6',
  arrowRight: 'M5 12h14m-6-6 6 6-6 6',
  card: 'M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Zm0 3h18M7 15h4',
  check: 'M4 12.5 9.5 18 20 6',
  speaker: 'M4 9.5h3.5L13 5v14l-5.5-4.5H4v-5ZM16.5 9a4 4 0 0 1 0 6M19 6.5a7.5 7.5 0 0 1 0 11',
  speakerOff: 'M4 9.5h3.5L13 5v14l-5.5-4.5H4v-5ZM17 9.5l5 5m0-5-5 5',
};

export default function Icon({ name, size = 18, strokeWidth = 1.8, style }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={style}
    >
      <path d={d} />
    </svg>
  );
}
